import Vue from 'vue';
import Vuex from 'vuex';

import world from '@/plugins/store.world';
import russia from '@/plugins/store.russia';
import russiaResort from '@/plugins/store.russiaResort';
import user from '@/plugins/store.user';
import oidc from '@/plugins/store.oidc';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		world,
		russia,
		russiaResort,
		oidc,
		user,
	},
	actions: {
		updateColors(context, colors) {
			context.dispatch('world/updateColors', colors.worldColors);
			context.dispatch('russia/updateColors', colors.russiaColors);
			context.dispatch('russiaResort/updateColors', colors.russiaResortColors);
		},
	},
});
